import { getAssetsPath } from 'common'

import { PlayerClass } from '@/types/profile'

export type GemAcquisition = {
  level: number
  Q?: string
  V?: string
} & {
  [cls in PlayerClass]?: ('Q' | 'V')[]
}

export const questToVendorsMap: Record<string, string> = {
  'Enemy at the Gate': 'Nessa',
  'Mercy Mission': 'Nessa',
  'Breaking Some Eggs': 'Nessa',
  'The Caged Brute': 'Nessa',
  "The Siren's Cadence": 'Nessa',
  'Intruders in Black': 'Yeena',
  'Sharp and Cruel': 'Yeena',
  'The Root of the Problem': 'Yeena',
  'Lost in Love': 'Clarissa',
  'Sever the Right Hand': 'Clarissa',
  'A Fixture of Fate': 'Siosa',
  'The Eternal Nightmare': 'Petarus and Vanja',
  'Breaking the Seal': 'Petarus and Vanja'
}

let gemAcquisition: Record<string, GemAcquisition> | undefined

export async function loadGemAcquisition() {
  if (gemAcquisition !== undefined) return gemAcquisition
  gemAcquisition = await fetch(getAssetsPath('gemAcquisition.min.json')).then((r) => r.json())
  return gemAcquisition
}
